<ng-container>
  <div *ngIf="licenseDetails$ | async as licenseDetails" class="licence-container">
    <span> {{ navbarLicenseTexts.version }} {{ version$ | async }}, </span>
    <span> {{ navbarLicenseTexts.expires }} {{ licenseDetails.expires }} </span>
    <ng-container *ngIf="licenseDetails.islimited">
      <span>{{ navbarLicenseTexts.assets_limit }} <b> {{ licenseDetails.assetsUsage }} </b> </span>
    </ng-container>
  </div>
</ng-container>
